<template>
    <section class="container-fluid" id="parent">
        <h1 class="page-heading">HIO Transient Parking Payments</h1>

        <div class="mb-3">
            <div class="row">
                <div class="col-sm-12">
                    <div class="btn-group mb-3" role="group">
                        <button type="button" :class="['btn', store.currentPage == 'AIRCRAFT' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('AIRCRAFT')">
                            Aircraft
                        </button>
                        <button type="button"
                                :disabled="store.progressPage < 1"
                                :class="['btn', store.currentPage == 'DATES' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('DATES')">
                            Arrival/Departure
                        </button>
                        <button type="button"
                                :disabled="store.progressPage < 2"
                                :class="['btn', store.currentPage == 'CONTACT' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('CONTACT')">
                            Contact
                        </button>
                        <button type="button"
                                :disabled="store.progressPage < 3"
                                :class="['btn', store.currentPage == 'PAYMENT' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('PAYMENT')">
                            Payment
                        </button>
                        <button type="button"
                                :disabled="store.progressPage < 4"
                                :class="['btn', store.currentPage == 'REVIEW' ? 'btn-outline-primary' : 'btn-primary']">
                            Review
                        </button>
                        <button type="button"
                                :disabled="store.progressPage < 5"
                                :class="['btn', store.currentPage == 'FINISH' ? 'btn-outline-primary' : 'btn-primary']">
                            Finish
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Aircraft v-show="store.currentPage == 'AIRCRAFT'" @goToPage="goToPage"></Aircraft>
        <Dates v-show="store.currentPage == 'DATES'" @goToPage="goToPage" @goBackToPage="goBackToPage"></Dates>
        <Contact v-show="store.currentPage == 'CONTACT'" @goToPage="goToPage" @goBackToPage="goBackToPage"></Contact>
        <Payment v-show="store.currentPage == 'PAYMENT'" @goToPage="goToPage" @goBackToPage="goBackToPage" :visible="store.currentPage == 'PAYMENT'"></Payment>
        <Review v-show="store.currentPage == 'REVIEW'" @goToPage="goToPage"></Review>
        <Finish v-show="store.currentPage == 'FINISH'"></Finish>

    </section>
</template>

<script setup>
    import { useStore } from './store';
    import Aircraft from './aircraft';
    import Dates from './dates';
    import Contact from './contact';
    import Payment from './payment';
    import Review from './review';
    import Finish from './finish';

    const store = useStore();

    function goToPage(pageName) {

        if (pageName == 'DATES' && store.progressPage < 1) {
            store.progressPage = 1;
        }

        if (pageName == 'CONTACT' && store.progressPage < 2) {
            store.progressPage = 2;
        }

        if (pageName == 'PAYMENT' && store.progressPage < 3) {
            store.progressPage = 3;
        }

        if (pageName == 'REVIEW' && store.progressPage < 4) {
            store.progressPage = 4;
        }

        if (pageName == 'FINISH' && store.progressPage < 5) {
            store.progressPage = 5;
        }

        store.currentPage = pageName;
    }

    function goBackToPage(pageName) {
        store.currentPage = pageName;
    }

</script>


